import { GET_ADDVEHICLE_REQUESTED, GET_DELETEVEHICLE_REQUESTED, GET_UPDATEVEHICLE_REQUESTED, GET_VEHICLE_REQUESTED, GET_MATRIXVEHICLE_REQUESTED, GET_MOREVEHICLE_REQUESTED } from "resources/actionTypes";

export function getVehicle(data) {
  return {
    type: GET_VEHICLE_REQUESTED,
    payload: data,
  };
}

export function postAddVehicle(userAddVehicle) {
  const data = {
    userAddVehicle: userAddVehicle,
  }
  return {
    type: GET_ADDVEHICLE_REQUESTED,
    payload: data,
  };
}

export function patchUpdateVehicle(userUpdateVehicle) {
  const data = {
    userUpdateVehicle: userUpdateVehicle,
  }
  return {
    type: GET_UPDATEVEHICLE_REQUESTED,
    payload: data,
  };
}

export function deleteVehicle(userDeleteVehicle) {
  const data = {
    userDeleteVehicle: userDeleteVehicle,
  }
  return {
    type: GET_DELETEVEHICLE_REQUESTED,
    payload: data,
  };
}

export function getMatrixVehicle(data) {
  return {
    type: GET_MATRIXVEHICLE_REQUESTED,
    payload: data,
  };
}

export function getMoreVehicle(data) {
  return {
    type: GET_MOREVEHICLE_REQUESTED,
    payload: data,
  };
}

